import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-open-access',
  templateUrl: './open-access.component.html',
  styleUrls: ['./open-access.component.scss']
})
export class OpenAccessComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
